import { render, staticRenderFns } from "./RevenueAccount.vue?vue&type=template&id=c8944a78&"
import script from "./RevenueAccount.vue?vue&type=script&lang=js&"
export * from "./RevenueAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports